import React from 'react';
import Header from './Header';
import { GalleryLeft, GalleryRight } from 'components';
import { data } from './data';
import * as S from './styles';

const Main: React.FC = () => {
  return (
    <S.Container>
      <Header />
      <S.Content>
        <S.Title>
          O melhor
          <br />
          está por vir
        </S.Title>
        <S.Text>
          <p>
            Contrariando os surrados clichês sobre envelhecimento – “Você não é
            mais útil ao mercado” ou “é chegada a hora do merecido descanso”,
            por exemplo –, a segunda metade da vida pode surpreender demais,
            representando uma mudança de rota, e por vezes até radical.
          </p>
          <p>
            Conheça a trajetória de dez mulheres que reinventaram sua história
            depois dos 50 anos de idade.
          </p>
          <p>
            <span>POR LÚCIA SOARES</span>
          </p>
        </S.Text>
      </S.Content>
      {data.map((item) =>
        item.type === 'left' ? (
          <GalleryLeft key={item.title} data={item} />
        ) : (
          <GalleryRight key={item.title} data={item} />
        )
      )}
    </S.Container>
  );
};

export default Main;
